import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import Updates from './components/Updates';
import Contact from './components/Contact';
import Comments from './components/Comments';
import Index from './components/Index';
import Topics from './components/Topics';
import Media from './components/Media';
import Faq from './components/Faq';
import App from './components/App';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <About />
        <Ranking />
        <Cards />
        <Updates />
        <Contact />
        <Comments />
        <Index />
        <Topics />
        <Media />
        <Faq />
        <App />
        <Carousel />
      </main>
      <Footer />
    </>
  );
}